import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

(function () {
  const TestimonialSlider = {
    init() {
      const self = this;

      self.settings();

      if (self.pm) {
        self.pm.addPersonalizedContentLoaded(function () {
          self.functionality();
        });
      } else {
        self.functionality();
      }
    },
    settings() {
      this.slideshows = document.querySelectorAll('.testimonial-slideshow') as NodeListOf<HTMLElement>;
      // @ts-ignore
      this.pm = window.personalizationManager;
    },
    functionality() {
      const self = this;

      self.slideshows.forEach((slideshow) => {
        const slider = slideshow.querySelector('.testimonial-slideshow__slider') as HTMLElement;
        const controls = slideshow.querySelector('.testimonial-slideshow__controls') as HTMLElement;
        const prev = controls.querySelector('.testimonial-slideshow__prev') as HTMLButtonElement;
        const next = controls.querySelector('.testimonial-slideshow__next') as HTMLButtonElement;

        if (slider.children.length > 2) {
          new Swiper(slideshow, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
            breakpoints: {
              768: {
                slidesPerView: 'auto',
                centeredSlides: true,
                spaceBetween: 45,
              },
            },
          });
        }
      });
    },
  };

  TestimonialSlider.init();
})();
